import { getSiblings } from '..'

let departmentMenuDom
let listItems

const closeExpanded = ()=> {
  listItems.forEach((_)=> _.classList.remove('open'))
}

const buttonClickHandler = (e)=> {
  if(e.target.parentElement.classList.contains('open')) {
    e.target.parentElement.classList.remove('open')
  } else {
    e.target.parentElement.classList.add('open')
    const siblings = getSiblings(e.target.parentElement)
    
    if(siblings && siblings.length > 0) {
        siblings.forEach((_)=>{
          _.classList.remove('open')
        })
    }
  }
}
(function () {
    const preloadedScript = function () {
        const nav = document.querySelector('#department-navigation--vertical')
        if (!nav) return;

        // Find all <a> elements inside the nav with the .active class
        const activeLinks = nav.querySelectorAll('.has-kids:has(ul> li a.active, > ul > li.active)')

        activeLinks.forEach(activeLink => {
            // Walk up: find the closest <li class="has-kids">
            let currentLi = activeLink.closest('.has-kids')
            let depth = 0;

            // Track up to two .has-kids ancestors: parent and grandparent
            while (currentLi && depth < 3) {
                currentLi.classList.add('open', 'active')
                const parentUl = currentLi.closest('ul')
                currentLi = parentUl ? parentUl.closest('.has-kids') : null
                depth++
            }
        });
    };

    const init = function () {
        preloadedScript();

        const menuToggleButton = document.querySelector(".leftnav-toggle button");
        const leftNav = document.querySelector(".department-navigation--vertical");

        if (!menuToggleButton || !leftNav) return;

        menuToggleButton.addEventListener("click", function () {
            leftNav.classList.toggle("show");

            const expanded = leftNav.classList.contains("show");
            menuToggleButton.setAttribute("aria-expanded", expanded);

            // Re-run the preload logic after showing the menu
            if (expanded) {
                preloadedScript();
            }
        });
    };

    // Run everything when DOM content is fully loaded
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();



const addEventListenerToDocumentClicks = ()=> {
  document.addEventListener('click', (e)=> {
    if(!departmentMenuDom.contains(e.target)) closeExpanded()
  })
}

export const addDepartmentSidebarMenuFunctionality = (ui)=> {
  if(!ui) return

  departmentMenuDom = ui
  listItems = departmentMenuDom.querySelectorAll('li')

  addEventListenerToDocumentClicks()

  departmentMenuDom.querySelectorAll('ul .has-kids > button').forEach((ele, key)=> {
    ele.addEventListener('click', buttonClickHandler)
  })
}